export { type BoxData, type DynamicHoverData } from '../../types/dynamicHover';
export { 
  detectAndMapDynamicHoverData, 
  shouldUseDynamicHover 
} from './dynamicHoverMapper';
export * from './giftsAndDonationsMapper';